import { hhmmss, convertYYYYMMDD } from '../../../util/date-time';
import { extend } from '../../../util/jquery.js';
export function marketsTimeSalesTransform(data) {
    const resultObj = extend({}, data);
    resultObj.data = (data.data || []).map(d => {
        return {
            gmtTime: d['-952'],
            gmtDate: convertYYYYMMDD(data.nextStartDate),
            price: d.price,
            size: d.size,
            exchange: d.exch,
            time: hhmmss(d.time),
            date: convertYYYYMMDD(d.date)
        };
    });
    return resultObj;
}
